import {
  ENVIO_CONTABILIDADE_ARQUIVO_STATUS_LABELS,
  ENVIO_CONTABILIDADE_EMAIL_LOG_STATUS_LABELS,
  ENVIO_CONTABILIDADE_PERIODO_LABELS,
  ENVIO_CONTABILIDADE_STATUS_LABELS,
  ENVIO_CONTABILIDADE_TIPO_EXECUCAO_LABELS,
} from "./constants";

export const labelPeriodo = periodo =>
  ENVIO_CONTABILIDADE_PERIODO_LABELS[periodo] || periodo || "-";

export const labelTipoExecucao = tipo =>
  ENVIO_CONTABILIDADE_TIPO_EXECUCAO_LABELS[tipo] || tipo || "-";

export const labelStatusExecucao = status =>
  ENVIO_CONTABILIDADE_STATUS_LABELS[status] || status || "-";

export const labelStatusArquivo = status =>
  ENVIO_CONTABILIDADE_ARQUIVO_STATUS_LABELS[status] || status || "-";

export const labelStatusEmailLog = status =>
  ENVIO_CONTABILIDADE_EMAIL_LOG_STATUS_LABELS[status] || status || "-";

export const formatDateTime = value => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = value => {
  if (!value) {
    return "-";
  }

  const date = new Date(`${value}T00:00:00`);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleDateString("pt-BR");
};

export const formatPeriodo = (inicio, fim) => {
  if (!inicio && !fim) {
    return "-";
  }

  return `${formatDate(inicio)} até ${formatDate(fim)}`;
};

export const formatBytes = bytes => {
  const value = Number(bytes || 0);

  if (!value) {
    return "-";
  }

  if (value < 1024) {
    return `${value} B`;
  }

  if (value < 1024 * 1024) {
    return `${(value / 1024).toFixed(1)} KB`;
  }

  return `${(value / 1024 / 1024).toFixed(1)} MB`;
};

export const normalizeCollection = payload => {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  return [];
};
